// modules
import { setUploadToken } from '@weblite/file'
// setup
import { getUserPermissionAndRegisterNotification } from '$setup/notification'
import { connect } from '$setup/ws'
import { setTwaAuthToken } from '$logic/twaCommunication'
import { getClientUserIdentityToken } from '$logic/auth'
import { getInstalledTwaVersion } from '$helper/functions/environmentInfo'
import { handleUrlToLoadAfterLogin } from '$logic/router'

const afterSignIn = () => {
  connect()
  getClientUserIdentityToken().then(setUploadToken)
  setTwaAuthToken()

  handleUrlToLoadAfterLogin()

  // Native notification implemented in version 6
  if (getInstalledTwaVersion() < 6)
    // TODO[router]: Remove the need of setTimeout
    setTimeout(() => getUserPermissionAndRegisterNotification(), 0)
}

export default afterSignIn
